import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHires = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 3.08398,
		y: 13.7139,
		width: 11.4286,
		height: 2.28571,
		rx: 1.14286,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.7043 6.82898C11.2858 10.8345 8.62282 12.5408 6.80398 13.2452C6.55378 13.3421 6.22776 12.7455 6.36096 12.5126C7.29641 10.8768 7.38391 8.17006 7.36319 6.82898H4.22656L9.33496 0L14.5123 6.82898H11.7043Z",
		fill: "currentColor"
	})]
});
export default SvgHires;
